import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Button, Card, Spinner } from 'react-bootstrap';
import { FaBarcode, FaBox, FaCheckCircle, FaShoppingCart } from 'react-icons/fa';

/**
 * Componente para mostrar una tarjeta de producto en el modal de selección
 * Soporta caracteres Unicode (acentos, ñ, símbolos especiales)
 */
const ProductoTarjeta = ({ producto, agregado, cargandoEsteProducto, onAgregarProducto }) => {
    return (
        <Card
            className="h-100 card-span border border-200 cursor-pointer"
        >
            <Card.Body className="p-3">
                {/* Badge de estado */}
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <Badge
                        bg={agregado ? "success" : "secondary"}
                        pill
                        style={{ fontSize: '0.65rem' }}
                    >
                        {agregado ? <><FaCheckCircle className="me-1" /> Agregado</> : <FaBox className="me-1" />}
                    </Badge>
                    <Badge
                        bg="200"
                        className="text-800 fs--2 fw-semi-bold border border-300"
                        style={{ fontSize: '0.7rem' }}
                    >
                        <FaBarcode className="me-1" />
                        {producto.vCodigoBarras}
                    </Badge>
                </div>

                {/* Nombre del producto - Nombre completo sin truncar */}
                <h6
                    className="mb-2 text-800 fw-semi-bold"
                    style={{
                        fontSize: '0.9rem',
                        minHeight: '40px',
                        wordWrap: 'break-word',
                        overflow: 'visible',
                        display: 'block',
                        lineHeight: '1.4',
                    }}
                >
                    {producto.vNombreProducto}
                </h6>

                {/* Precio */}
                <div className="mb-3">
                    <span className="text-500 fs--2">Precio Unitario</span>
                    <div className="text-primary fw-bold fs-1">
                        ${producto.dTotal?.toFixed(2)} <span className="text-500 fw-normal fs--1">{producto.vMoneda}</span>
                    </div>
                </div>

                {/* Botón de acción */}
                <Button
                    size="sm"
                    variant={agregado ? "warning" : "primary"}
                    className="w-100 rounded-2 fw-medium"
                    onClick={() => onAgregarProducto(producto.idProducto)}
                    disabled={cargandoEsteProducto}
                >
                    {cargandoEsteProducto ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Agregando...
                        </>
                    ) : agregado ? (
                        <>
                            <FaShoppingCart className="me-2" />
                            Agregar otra vez
                        </>
                    ) : (
                        <>
                            <FaShoppingCart className="me-2" />
                            Agregar
                        </>
                    )}
                </Button>
            </Card.Body>
        </Card>
    );
};

ProductoTarjeta.propTypes = {
    producto: PropTypes.shape({
        idProducto: PropTypes.number.isRequired,
        vNombreProducto: PropTypes.string.isRequired,
        vCodigoBarras: PropTypes.string,
        dTotal: PropTypes.number,
        vMoneda: PropTypes.string
    }).isRequired,
    agregado: PropTypes.bool.isRequired,
    cargandoEsteProducto: PropTypes.bool.isRequired,
    onAgregarProducto: PropTypes.func.isRequired
};

export default ProductoTarjeta;